<template>
  <div class="page-wrap">

    <canvas id="barcode" class="d-none" style="width:inherit;height:95px"></canvas>

    <appointmentDetailModal :key="key" v-if="appointmentDetailModalShow" v-on:closemodal="closeModal"
      v-on:updatepaymentstatus="updatepaymentstatus" :loading-data="loadingData" :has-data="hasData"
      :show-modal="appointmentDetailModalShow" :appointment-data="appointmentData" :index-num="currentIndex"
      :show-qr-code="showQrCode" :token="token" @reLoadTable="reTableReload" @reload="search"></appointmentDetailModal>

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header" v-if="AppType">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-calendar-alt"></i></div>
          <div>
            <div class="panel-title">
              Appointments
              <span class="count-badge" v-if="pagination.total_records > 0">{{ pagination.total_records }}</span>
            </div>
            <div class="panel-sub">Browse, filter and manage all scheduled appointments</div>
          </div>
        </div>
      </div>

      <!-- Toolbar -->
      <div class="toolbar" v-if="AppType">

        <!-- Row 1: Search by appointment number/name -->
        <div class="toolbar-row">
          <div class="search-box">
            <i class="fa fa-search"></i>
            <input type="text" placeholder="Search by appointment no or name…" v-model="search_text"
              @keypress.enter="search()" />
            <button v-if="search_text" class="search-clear" @click="search_text = ''; search()">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <button class="btn-search" @click="search()">
            <i class="fa fa-search"></i> Search
          </button>
        </div>

        <!-- Row 2: Filters -->
        <div class="toolbar-row toolbar-filters">

          <!-- Date From / To -->
          <input type="date" class="filter-date" v-model="date_from" @keypress.enter="advSearch()" />
          <input type="date" class="filter-date" v-model="date_to" @keypress.enter="advSearch()" />

          <!-- Location — type-and-select -->
          <div class="ts-wrap" v-if="!currentUser.u.is_client" :class="{ open: locOpen }"
            v-click-outside="closeLocDropdown">
            <div class="ts-field" @click="toggleLoc">
              <i class="fa fa-map-marker-alt ts-icon"></i>
              <input class="ts-input" ref="locInput" :value="locOpen ? locSearch : locLabel"
                @input="locSearch = $event.target.value" @focus="openLoc" placeholder="All Locations" />
              <i class="fa fa-chevron-down ts-arrow" :class="{ 'ts-arrow--open': locOpen }"></i>
            </div>
            <div class="ts-menu" v-if="locOpen">
              <div class="ts-opt" :class="{ 'ts-opt--sel': serviceOutlet === 'all' }"
                @mousedown.prevent="selectLoc('all', 'All Locations')">All Locations</div>
              <div class="ts-opt" v-for="(c, i) in filteredLoc" :key="i"
                :class="{ 'ts-opt--sel': serviceOutlet === c.id }" @mousedown.prevent="selectLoc(c.id, c.name)">{{
                  c.name }}</div>
              <div class="ts-empty" v-if="!filteredLoc.length && locSearch">No matches</div>
            </div>
          </div>

          <!-- Service -->
          <select class="filter-select" v-model="service">
            <option value="all">All Services</option>
            <option v-for="(c, i) in getServices" :key="i" :value="c.id">{{ c.name }}</option>
          </select>

          <!-- App Status -->
          <select class="filter-select" v-model="status">
            <option value="all">All Statuses</option>
            <option value="P">Pending</option>
            <option value="C">Completed</option>
            <option value="U">No-Show</option>
            <option value="Cancel">Canceled</option>
          </select>

          <!-- Payment Status -->
          <select class="filter-select" v-model="payment_status">
            <option value="all">All Payments</option>
            <option value="C">Card</option>
            <option value="O">On-site</option>
            <option value="A">Abbreviation</option>
            <option value="CP">Company Payment</option>
          </select>

          <button class="btn-search" @click="advSearch()">
            <i class="fa fa-search"></i> Search
          </button>
        </div>
      </div>

      <!-- Table -->
      <div class="table-wrap">

        <div class="state-box" v-if="getLoadingData">
          <i class="fa fa-spinner fa-spin"></i>
          Loading…
        </div>

        <div class="state-box" v-else-if="appoinments.length === 0">
          <i class="fa fa-calendar-times"></i>
          No appointments found
        </div>

        <!-- Full appointment list -->
        <table class="appt-table" v-else-if="AppType && DashType === 'appointment_list'">
          <thead>
            <tr>
              <th>Date / Time</th>
              <th>App #</th>
              <th>Type</th>
              <th>Applicant</th>
              <th>Service / Location</th>
              <th class="col-right">Amount</th>
              <th class="col-center">Abbr.</th>
              <th>Status</th>
              <th>Payment</th>
              <th class="col-center">Paid</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in appoinments" :key="index">
              <td>
                <div class="cell-date" v-if="item.schedule_date">{{ item.schedule_date | dateFormat }}</div>
                <div class="cell-date" v-else-if="item.created_at">{{ item.created_at | dateFormat }}</div>
                <div class="cell-date muted" v-else>N/A</div>
                <div class="cell-sub" v-if="item.schedule_date && item.start_time">{{ item.start_time |
                  timeFormat(item.schedule_date) }}</div>
              </td>
              <td>
                <a class="app-link" href="javascript:void(0)"
                  @click="openAppointmentDetail(item.id, item.token, index, true)">#{{ item.id }}</a>
              </td>
              <td>
                <span class="type-tag">{{ !item.app_type ? 'Live Scan' : capitalize(item.app_type) }}</span>
              </td>
              <td class="cell-applicant">{{ item.applicant }}</td>
              <td>
                <div class="cell-name">{{ item.service }}<span v-if="item.is_additional">, {{ item.is_additional
                }}</span></div>
                <div class="cell-sub">{{ item.client }}</div>
              </td>
              <td class="col-right cell-amount">${{ item.amount | toFixedTwoDigit }}</td>
              <td class="col-center cell-abbr">{{ item.abbreviation_code && item.abbreviation_code !== '' ?
                item.abbreviation_code : '—' }}</td>
              <td>
                <!-- Inline status edit -->
                <div class="status-edit" v-if="item.change_status_flag">
                  <select class="status-select" v-model="item.new_status">
                    <option value="P">Pending</option>
                    <option value="C">Completed</option>
                    <option value="U">No-Show</option>
                    <option value="Cancel">Cancel</option>
                  </select>
                  <button class="se-btn confirm" v-if="item.appt_status !== item.new_status"
                    @click="updateStatusChangesFlag(item.id, index, item.new_status)">
                    <i class="fa fa-check"></i>
                  </button>
                  <button class="se-btn cancel" @click="closeChangeStatusFlag(index)">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <span v-else class="badge-status" :class="'s-' + statusColor(item.appt_status)" style="cursor:pointer"
                  @click="changeStatusOpen(item.id, index)">
                  {{ item.appt_status | apptStatus }}
                </span>
              </td>
              <td>
                <span class="badge-payment" :class="'p-' + item.payment_type" style="cursor:pointer"
                  @click="openAppointmentDetail(item.id, item.token, index, false)">
                  {{ item.payment_type | payementStatus }}
                </span>
              </td>
              <td class="col-center">
                <i class="fa fa-check-circle paid-yes" v-if="item.payment_status === 'P'"></i>
                <i class="fa fa-times-circle paid-no" v-else-if="item.payment_status === 'U'"></i>
                <span class="badge-refund" v-else-if="item.payment_status === 'Refund'">Refunded</span>
              </td>
              <td class="col-right">
                <a v-if="item.payment_status === 'P' && item.appt_status !== 'Cancel'" class="btn-invoice"
                  href="javascript:void(0)" @click="openInvoice(item.token)">
                  Invoice <i class="fa fa-arrow-right"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Today view -->
        <table class="appt-table" v-else-if="!AppType && DashType === 'today'">
          <thead>
            <tr>
              <th>Time</th>
              <th>App #</th>
              <th>Applicant</th>
              <th>Service / Location</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in appoinments" :key="index">
              <td class="cell-date">{{ item.start_time | timeFormat(item.schedule_date) }}</td>
              <td><a class="app-link" href="javascript:void(0)"
                  @click="openAppointmentDetail(item.id, item.token, index, false)">#{{ item.id }}</a></td>
              <td class="cell-applicant">{{ item.applicant }}</td>
              <td>
                <div class="cell-name">{{ item.service }}</div>
                <div class="cell-sub">{{ item.client }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Upcoming / other -->
        <table class="appt-table" v-else-if="!AppType">
          <thead>
            <tr>
              <th>Date / Time</th>
              <th>App #</th>
              <th>Applicant</th>
              <th>Service / Location</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in appoinments" :key="index">
              <td>
                <div class="cell-date">{{ item.schedule_date | dateFormat }}</div>
                <div class="cell-sub">{{ item.start_time | timeFormat(item.schedule_date) }}</div>
              </td>
              <td class="cell-date">{{ item.id }}</td>
              <td class="cell-applicant">{{ item.applicant }}</td>
              <td>
                <div class="cell-name">{{ item.service }}</div>
                <div class="cell-sub">{{ item.client }}</div>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- Pagination -->
      <div class="pagination-bar" v-if="pagination.total_page > 1">
        <span class="pg-info">
          Page {{ pagination.current_page }} of {{ pagination.total_page }}
          <span v-if="pagination.total_records"> · {{ pagination.total_records }} records</span>
        </span>
        <div class="pg-controls">
          <button class="pg-btn" :disabled="pagination.current_page === 1" @click="firstPage()">
            <i class="fa fa-angle-double-left"></i>
          </button>
          <button class="pg-btn" :disabled="pagination.current_page === 1" @click="previousPage()">
            <i class="fa fa-angle-left"></i>
          </button>
          <button v-for="p in visiblePages" :key="p" class="pg-btn" :class="{ active: p === pagination.current_page }"
            @click="selectedPage(p)">{{ p }}</button>
          <button class="pg-btn" :disabled="pagination.current_page === pagination.total_page" @click="nextPage()">
            <i class="fa fa-angle-right"></i>
          </button>
          <button class="pg-btn" :disabled="pagination.current_page === pagination.total_page" @click="lastPage()">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  FETCH_CLIENT_APPOINTMENT,
  FETCH_CLIENTS,
  FETCH_SERVICES,
  UPDATE_APPOINTMENT_STATUS,
  FETCH_SELF_APPOINMENT,
  APPOINTMENT_LOGS
} from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import * as PDF417 from "pdf417-generator";
import appointmentDetailModal from "@/components/frontend/modal/appointmentdetail";

export default {
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutsideHandler = e => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener("mousedown", el._clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el._clickOutsideHandler);
      }
    }
  },
  components: { appointmentDetailModal },
  computed: {
    ...mapGetters(["currentUser", "getClients", "getServices"]),
    filteredLoc() {
      const q = this.locSearch.toLowerCase();
      return (this.getClients || []).filter(c => !q || c.name.toLowerCase().includes(q));
    },
    locLabel() {
      if (this.serviceOutlet === "all") return "";
      const found = (this.getClients || []).find(c => c.id === this.serviceOutlet);
      return found ? found.name : "";
    },
    visiblePages() {
      const pages = [];
      const cur = this.pagination.current_page;
      const total = this.pagination.total_page;
      for (let i = Math.max(1, cur - 2); i <= Math.min(total, cur + 2); i++) pages.push(i);
      return pages;
    }
  },
  props: {
    AppType: { type: Boolean, default: true },
    DashType: { type: String, default: "appointment_list" }
  },
  filters: {
    toFixedTwoDigit(amount) { return parseFloat(amount).toFixed(2); },
    timeFormat(value, date) {
      if (!date) return;
      return moment(date + " " + value).format("hh:mm a");
    },
    dateFormat(date) {
      if (!date) return;
      return moment(date).format("MM/DD/YYYY");
    },
    payementStatus(status) {
      const map = { C: "Card", A: "Abbreviation", O: "On-site", CP: "Company Pmt", Cancel: "Cancel" };
      return map[status] || status;
    },
    apptStatus(status) {
      const map = { P: "Pending", C: "Completed", U: "No-Show", Cancel: "Canceled" };
      return map[status] || status;
    }
  },
  data() {
    return {
      appointmentDetailModalShow: false,
      showQrCode: false,
      getLoadingData: false,
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Appointment List", route: "" }
      ],
      service: "all",
      serviceOutlet: "all",
      date_from: this.$moment(new Date()).format("YYYY-MM-DD"),
      date_to: this.$moment(new Date()).add(7, "days").format("YYYY-MM-DD"),
      status: "all",
      payment_status: "all",
      appoinments: [],
      pagination: {
        total_records: 0,
        total_page: 0,
        current_page: 1,
        per_page_data: 15,
        received_per_page_data: 15
      },
      selectedAppId: 0,
      appointmentData: {},
      currentIndex: -1,
      loadingData: false,
      hasData: false,
      msg: "",
      search_text: "",
      token: "",
      key: 0,
      locOpen: false,
      locSearch: ""
    };
  },
  mounted() {
    if (window.localStorage.getItem("appoitmentsearch") != null) {
      let s = JSON.parse(window.localStorage.getItem("appoitmentsearch"));
      this.status = s.status;
      this.service = s.service;
      this.serviceOutlet = s.service_outlet || "all";
      this.date_from = s.date_from || this.$moment(new Date()).format("YYYY-MM-DD");
      this.date_to = s.date_to || this.$moment(new Date()).add(7, "days").format("YYYY-MM-DD");
      this.payment_status = s.payment_status;
      this.$store.dispatch(FETCH_SERVICES, this.serviceOutlet);
    } else {
      this.serviceOutlet = this.currentUser.u.is_client ? "self" : "all";
      this.$store.dispatch(FETCH_SERVICES, this.serviceOutlet);
    }
    this.$store.dispatch(FETCH_CLIENTS);
    if (this.AppType) this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.appData();
  },
  methods: {
    /* ── Location type-and-select ── */
    openLoc() { this.locOpen = true; this.locSearch = ""; this.$nextTick(() => this.$refs.locInput && this.$refs.locInput.focus()); },
    toggleLoc() { this.locOpen ? this.closeLocDropdown() : this.openLoc(); },
    closeLocDropdown() { this.locOpen = false; this.locSearch = ""; },
    selectLoc(id) {
      this.serviceOutlet = id;
      this.locOpen = false;
      this.locSearch = "";
      this.loadServices();
    },

    /* ── Search / filter ── */
    search() {
      this.pagination = { total_records: 0, total_page: 0, current_page: 1, per_page_data: 15, received_per_page_data: 15 };
      this.appData();
    },
    advSearch() { this.search_text = ""; this.search(); },

    /* ── Modal ── */
    closeModal() { this.appointmentDetailModalShow = false; },
    reTableReload(index) { this.appoinments[index].payment_status = "Refund"; },
    updatepaymentstatus(i, ps, is_drug_testing) {
      if (is_drug_testing) this.refreshData();
      this.appoinments[i].payment_status = ps;
    },
    openInvoice(token) {
      this.$router.push({ name: "client.invoice.details", params: { slug: this.$route.params.client_slug, token } });
    },
    openAppointmentDetail(appId, token, index, showQrCode) {
      let now = moment(new Date());
      let appt_date = moment(this.appoinments[index].schedule_date + " " + this.appoinments[index].start_time);
      if (this.appoinments[index].cancel == 1 && this.currentUser.u.is_client) return;
      if ((now.diff(appt_date, "hours") >= 24 && this.currentUser.u.is_client) ||
        (this.currentUser.u.is_client && this.appoinments[index].is_locked == 1)) return;

      this.showQrCode = showQrCode;
      this.currentIndex = index;
      this.appointmentDetailModalShow = true;
      this.selectedAppId = appId;
      this.loadingData = true;

      this.$store.dispatch(FETCH_SELF_APPOINMENT, { token, appointment_id: appId })
        .then(res => {
          this.appointmentData = res.data;
          this.token = token;
          this.loadingData = false;
          this.hasData = res.hasData;
          this.key += 1;
          if (showQrCode) {
            var DBB = this.$moment(res.data.dob).format("MMDDYYYY");
            var DBC = res.data.gender == "Female" ? 2 : 1;
            var DAU = ((res.data.height * 12) / 100).toFixed(2);
            var value = "@\n\nANSI 636020090102DL00410279ZC03200010DLDAQ171774992\nDCA\nDCB\nDCD\nDBA\nDCS" +
              res.data.lname + "\nDAC" + res.data.fname + "\nDAD" + res.data.mname +
              "\nDBD\nDBB" + DBB + "\nDBC" + DBC + "\nDAY" + res.data.eye_color +
              "\nDAU0" + DAU * 100 + " in\nDAG\nDAI" + res.data.city + "\nDAJ" + res.data.address +
              "\nDAK" + res.data.zipcode + "\nDAQ\nDCF\nDCG\nDDE\nDDF\nDDG";
            var canvas = document.getElementById("barcode");
            PDF417.draw(value, canvas);
            res.data.barcode_base64 = canvas.toDataURL("image/png");
          }
          this.appointmentData = res.data;
          this.$store.dispatch(APPOINTMENT_LOGS, { app_id: appId });
        })
        .catch(() => { this.loadingData = false; });
    },

    /* ── Status change ── */
    refreshData() {
      this.pagination = { total_records: 0, total_page: 0, current_page: 1, per_page_data: 15, received_per_page_data: 15 };
      this.appData();
    },
    closeChangeStatusFlag(index) {
      this.selectedAppId = 0;
      this.appoinments[index].change_status_flag = false;
    },
    storeStatusChange(appId, appt_status, index, status) {
      this.$store.dispatch(UPDATE_APPOINTMENT_STATUS, { app_id: appId, appt_status })
        .then(res => {
          this.$toastr.s(res.msg);
          this.appoinments[index].appt_status = status;
          this.appoinments[index].cancel = status === "Cancel" ? 1 : 0;
          this.closeChangeStatusFlag(index);
        })
        .catch(err => { this.$toastr.e(err.msg); });
    },
    updateStatusChangesFlag(appId, index, appt_status) {
      var status = this.appoinments[index].new_status;
      if (status !== this.appoinments[index].appt_status) {
        if (status === "Cancel") {
          this.$swal.fire({
            title: "Are you sure?",
            text: `You want to cancel appointment no. ${this.appoinments[index].id}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
          }).then(result => {
            if (result.isConfirmed) this.storeStatusChange(appId, appt_status, index, status);
            else this.closeChangeStatusFlag(index);
          });
        } else {
          this.storeStatusChange(appId, appt_status, index, status);
        }
      } else {
        this.appoinments[index].appt_status = status;
        this.closeChangeStatusFlag(index);
      }
    },
    changeStatusOpen(appointMentId, index) {
      if (this.appoinments[index].cancel == 0 || this.currentUser.u.is_service_provider) {
        this.selectedAppId = appointMentId;
        this.appoinments[index].change_status_flag = true;
      }
    },
    statusColor(status) {
      const map = { P: "warning", C: "success", U: "info", Cancel: "danger" };
      return map[status] || "secondary";
    },

    /* ── Pagination ── */
    selectedPage(n) { this.pagination.current_page = n; this.appData(); },
    nextPage() { this.pagination.current_page++; this.appData(); },
    lastPage() { this.pagination.current_page = this.pagination.total_page; this.appData(); },
    firstPage() { this.pagination.current_page = 1; this.appData(); },
    previousPage() { this.pagination.current_page--; this.appData(); },

    loadServices() {
      this.service = "all";
      this.$store.dispatch(FETCH_SERVICES, this.serviceOutlet);
    },
    capitalize(value) {
      return value.replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
    },
    appData() {
      this.appoinments = [];
      this.getLoadingData = true;
      var data = {
        service: this.service,
        service_outlet: this.serviceOutlet,
        date_from: this.date_from,
        date_to: this.date_to,
        type: this.currentUser.u.is_admin ? "admin" : this.currentUser.u.is_client ? "c" : "sp",
        status: this.status,
        payment_status: this.payment_status,
        page: this.pagination.current_page,
        search_text: this.search_text,
        dtype: "appointment_list"
      };
      window.localStorage.setItem("appoitmentsearch", JSON.stringify(data));
      if (this.DashType === "today") data.dtype = "today";
      else if (this.DashType === "upcomming") data.dtype = "upcomming";

      this.$store.dispatch(FETCH_CLIENT_APPOINTMENT, data)
        .then(res => {
          this.getLoadingData = false;
          this.appoinments = res.data;
          this.pagination.total_records = res.total_record;
          this.pagination.total_page = res.page_range;
          this.pagination.received_per_page_data = res.data.length;
          this.pagination.per_page_data = this.DashType === "appointment_list" ? 15 : 8;
        })
        .catch(err => { this.getLoadingData = false; this.msg = err.error; });
    }
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$green: #276749;
$dark: #0d1b3e;
$border: #dde2ec;

.page-wrap {
  padding: 8px 0 80px;
  font-family: $font;
}

/* ── Panel ── */
.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: clip;
}

/* ── Header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #fafbfd;
  border-bottom: 1px solid #eef0f6;
  gap: 10px;
  flex-wrap: wrap;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
  display: flex;
  align-items: center;
  gap: 8px;
}

.count-badge {
  font-size: 11px;
  font-weight: 600;
  color: #7a8499;
  background: #eef0f6;
  border-radius: 10px;
  padding: 1px 7px;
}

.panel-sub {
  font-size: 11px;
  color: #8a94a6;
  margin-top: 2px;
}

/* ── Toolbar ── */
.toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 20px;
  border-bottom: 1px solid #f0f3fa;
}

.toolbar-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.toolbar-filters {
  gap: 6px;
}

.search-box {
  position: relative;
  flex: 1;
  min-width: 200px;
  max-width: 300px;

  i {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #a0aab8;
    font-size: 12px;
    pointer-events: none;
  }

  input {
    width: 100%;
    height: 36px;
    border: 1.5px solid $border;
    border-radius: 8px;
    padding: 0 30px 0 30px;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    outline: none;
    background: #fff;
    transition: border-color 0.2s;

    &::placeholder {
      color: #b0bac9;
    }

    &:focus {
      border-color: $blue;
      box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
    }
  }
}

.search-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #a0aab8;
  cursor: pointer;
  font-size: 11px;
  padding: 0;

  &:hover {
    color: $dark;
  }
}

.filter-select {
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 28px 0 10px;
  font-size: 12px;
  font-family: $font;
  color: $dark;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23a0aab8'/%3E%3C/svg%3E") no-repeat right 10px center;
  appearance: none;
  outline: none;
  cursor: pointer;
  // width: 160px;
  transition: border-color 0.2s;
  margin: 0 0 0 0;

  &:focus {
    border-color: $blue;
  }
}

.filter-date {
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 12px;
  font-family: $font;
  color: $dark;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: $blue;
  }
}

.btn-search {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  background: $blue;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: opacity 0.2s;

  i {
    font-size: 11px;
  }

  &:hover {
    opacity: 0.9;
  }
}

/* ── Type-and-select ── */
.ts-wrap {
  position: relative;
  min-width: 160px;
  max-width: 210px;
}

.ts-field {
  display: flex;
  align-items: center;
  height: 36px;
  border: 1.5px solid $border;
  border-radius: 8px;
  background: #fff;
  padding: 0 10px;
  gap: 7px;
  cursor: pointer;
  transition: border-color 0.2s;

  .ts-wrap.open & {
    border-color: $blue;
    box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
  }
}

.ts-icon {
  font-size: 11px;
  color: #a0aab8;
  flex-shrink: 0;
}

.ts-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 12px;
  font-family: $font;
  color: $dark;
  background: transparent;
  min-width: 0;
  cursor: pointer;

  &::placeholder {
    color: #b0bac9;
  }
}

.ts-arrow {
  font-size: 10px;
  color: #a0aab8;
  flex-shrink: 0;
  transition: transform 0.2s;

  &--open {
    transform: rotate(180deg);
  }
}

.ts-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1.5px solid $border;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(13, 27, 62, 0.1);
  z-index: 500;
  max-height: 220px;
  overflow-y: auto;
}

.ts-opt {
  padding: 8px 12px;
  font-size: 12px;
  color: $dark;
  cursor: pointer;
  transition: background 0.12s;

  &:hover {
    background: #f0f7fc;
  }

  &--sel {
    background: #eef7fb;
    color: $blue;
    font-weight: 600;
  }
}

.ts-empty {
  padding: 10px 12px;
  font-size: 12px;
  color: #a0aab8;
  text-align: center;
}

/* ── Table ── */
.table-wrap {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 560px;
}

.state-box {
  text-align: center;
  padding: 48px 24px;
  color: #a0aab8;
  font-size: 13px;

  i {
    font-size: 28px;
    display: block;
    margin-bottom: 10px;
    opacity: 0.45;
  }
}

.appt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  font-family: $font;

  thead tr {
    background: #fff;
    border-bottom: 2px solid #eef0f8;
    position: sticky;
    top: 0;
    z-index: 2;

    th {
      padding: 18px 12px;
      text-align: left;
      font-size: 11px;
      font-weight: 700;
      color: #7a8499;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      white-space: nowrap;

      &.col-right {
        text-align: right;
      }

      &.col-center {
        text-align: center;
      }
    }
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child {
      border-bottom: none;
    }

    &:hover td {
      background: #f8fbff;
    }

    td {
      padding: 14px 12px;
      color: $dark;
      vertical-align: middle;

      &.col-right {
        text-align: right;
      }

      &.col-center {
        text-align: center;
      }
    }
  }
}

/* ── Cell helpers ── */
.cell-date {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}

.cell-date.muted {
  color: #c0c7d4;
}

.cell-sub {
  font-size: 11px;
  color: #6b7280;
  margin-top: 3px;
}

.cell-name {
  font-size: 13px;
  color: $dark;
}

.cell-applicant {
  white-space: nowrap;
  color: $dark;
}

.cell-amount {
  font-family: monospace;
  font-weight: 600;
  white-space: nowrap;
}

.cell-abbr {
  font-size: 12px;
  color: #7a8499;
  font-family: monospace;
}

.app-link {
  font-weight: 700;
  color: $blue;
  text-decoration: none;
  font-size: 13px;

  &:hover {
    text-decoration: underline;
  }
}

.type-tag {
  display: inline-block;
  padding: 2px 8px;
  background: #f0f4ff;
  color: #3b5bdb;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

/* ── Inline status edit ── */
.status-edit {
  display: flex;
  align-items: center;
  gap: 4px;

  .status-select {
    height: 28px;
    border: 1.5px solid $border;
    border-radius: 6px;
    padding: 0 6px;
    font-size: 12px;
    font-family: $font;
    color: $dark;
    outline: none;
    background: #fff;

    &:focus {
      border-color: $blue;
    }
  }

  .se-btn {
    width: 26px;
    height: 26px;
    border: none;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    cursor: pointer;
    flex-shrink: 0;

    &.confirm {
      background: #dcfce7;
      color: #166534;

      &:hover {
        background: #bbf7d0;
      }
    }

    &.cancel {
      background: #fee2e2;
      color: #b91c1c;

      &:hover {
        background: #fecaca;
      }
    }
  }
}

/* ── Badges ── */
.badge-status {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;

  &.s-warning {
    background: #fef9c3;
    color: #854d0e;
  }

  &.s-success {
    background: #dcfce7;
    color: #166534;
  }

  &.s-info {
    background: #e0f2fe;
    color: #0369a1;
  }

  &.s-danger {
    background: #fee2e2;
    color: #b91c1c;
  }

  &.s-secondary {
    background: #e2e8f0;
    color: #64748b;
  }
}

.badge-payment {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  background: #dbeafe;
  color: #1d4ed8;

  &.p-O {
    background: #dcfce7;
    color: #166534;
  }

  &.p-A {
    background: #ede9fe;
    color: #6b21a8;
  }

  &.p-CP {
    background: #fef3c7;
    color: #92400e;
  }
}

.paid-yes {
  color: #16a34a;
  font-size: 15px;
}

.paid-no {
  color: #dc2626;
  font-size: 15px;
}

.badge-refund {
  display: inline-block;
  padding: 2px 8px;
  background: #fee2e2;
  color: #b91c1c;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
}

.btn-invoice {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
  border-radius: 7px;
  font-size: 11.5px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.15s;

  &:hover {
    background: #dcfce7;
    border-color: #86efac;
  }
}

/* ── Pagination ── */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #f0f3fa;
  flex-wrap: wrap;
  gap: 10px;
}

.pg-info {
  font-size: 12px;
  color: #7a8499;
}

.pg-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pg-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1.5px solid $border;
  background: #fff;
  color: #4a5568;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover:not(:disabled) {
    border-color: $blue;
    color: $blue;
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }

  &.active {
    background: $blue;
    border-color: $blue;
    color: #fff;
  }
}
</style>
